export function Home() {
  return (
    <path
      fill="currentColor"
      d="M5 20V9.5l7-5.288L19 9.5V20h-5.192v-6.385h-3.616V20z"
    ></path>
  )
}
